import Axios from "axios"


export async function notice_save(props) {
    const ckeditor = props['ckeditor']
    const Set_noticeList = props['Set_noticeList']
    const noticeTitle = props['noticeTitle']

    if(window.confirm('저장하시겠습니까?')) {
        const branch_id = window.EventManager['branchInfo']['id']
        const notice_id = document.getElementById('notice_id').value
        const content = await ckeditor.getData()

        const result = await Axios
                        .post("/notice/save", {
                            branch_id: branch_id,
                            notice_id: notice_id,
                            title: noticeTitle,
                            content: content
                        })
        const data = result['data']
        alert(data['message'])
        if(data['status'] === 'success') {
            Set_noticeList([...data['list']])
        }
    }
}